import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ConfigService } from '@services/config.service';
import { Subscription } from 'rxjs';
import { AppService } from '../services/app.service';
import { DeliveryService } from '../services/delivery.service';
import { ExamineeloginService } from '../services/examineelogin.service';
import { WebErrorService } from '@services/webError.service';

@Component({
  selector: 'app-examineelogin',
  templateUrl: './examineelogin.component.html',
  styleUrls: ['./examineelogin.component.scss']
})
export class ExamineeloginComponent implements OnInit, OnDestroy {

  loginForm: FormGroup;
  isSubmitted = false;
  loginSpinner = false;
  submitted = false;
  loginErrorMessage: string;
  isLoginError = false;
  userServiceSubscription$: Subscription;
  constructor(private fb: FormBuilder, private appService: AppService,
    private examineeloginservice: ExamineeloginService,
    private webErrorService: WebErrorService,
    private deliveryservice: DeliveryService, private router: Router,
    public configService: ConfigService) { }
  useruuid: number;

  tests: any[] = [];
  testsSubscription$: Subscription;
  testsDataSource: any;

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
    });

    this.appService.changeUserHeader(0);

    if (sessionStorage.getItem('currentUser')) {
      this.useruuid = JSON.parse(sessionStorage.getItem('currentUser') || '{}').useruuid;
      this.testsSubscription$ = this.deliveryservice.getTest(this.useruuid).subscribe(
        (data: any) => {
          this.tests.push(data);
          this.testsDataSource = new MatTableDataSource(this.tests);
        },
        (error: any) => {
          this.webErrorService.handleAPIErrors(error);
        });
    }

  }

  get f(): any {
    return this.loginForm.controls;
  }

  login(): void {
    let d
    this.loginSpinner = true;
    this.isSubmitted = true;
    if (this.loginForm.valid) {
      this.userServiceSubscription$ = this.examineeloginservice
        .login(this.loginForm.value.email, this.loginForm.value.password)
        .subscribe(
          (data: any) => {
            // this.router.navigate(['/users'])
            this.appService.changeUserHeader(0);
            // this.router.navigate(["tests/start", this.userId ]);
            // this.router.navigate(['/examineework']);
          },
          error => {
            d = error.error.message,

              this.loginErrorMessage = 'Your email or password is incorrect. Try again';
          }
        );
    }
  }


  ngOnDestroy(): void {
    this.userServiceSubscription$.unsubscribe();
  }
}
